import { EuiButton } from "@inscopix/ideas-eui";
import { withUserPermission } from "hocs/withUserPermission";
import { withUserPermissionBase } from "hocs/withUserPermissionBase";

/**
 * Enhanced {@link EuiButton} that is disabled when the user lacks a
 * required permission.
 *
 * Context independent.
 */
export const ButtonPermissionedBase = withUserPermissionBase(EuiButton);

/**
 * Enhanced {@link EuiButton} that is disabled when the user lacks a
 * required permission.
 *
 * Reads permissions from project permissions context.
 */
export const ButtonPermissioned = withUserPermission(ButtonPermissionedBase);
